import React, { useState, useEffect } from "react";

const ConnectTab = ({ updateWhatsAppTabData, whatsAppTabData }) => {
    const [whatsAppNumber, setwhatsAppNumber] = useState("");

    useEffect(() => {
        if (whatsAppTabData?.content_number) {
            setwhatsAppNumber(whatsAppTabData.content_number);
        }
    }, [whatsAppTabData?.content_number]);

    const handleInputChange = (event) => {
        const value = event.target.value;
        setwhatsAppNumber(value);
        updateWhatsAppTabData("content_number", value);
    };

    return (
        <div className="whats-app-side-baar-connect-tab">
            <span>Connect</span>
            <div className="source-serach-baar">
                <div className="google-search-container">
                    <input
                        type="text"
                        value={whatsAppNumber}
                        onChange={handleInputChange}
                        placeholder="WhatsApp Number or Link"
                    />
                </div>
            </div>
            <p>Example: +65 6909 9163 </p>
            <p>
                Please include country code and do not start with 0 or 00. For WhatsApp Business Account use a  
                <a href="https://faq.whatsapp.com/502291734918768/?locale=en_US&cms_platform=android" target="_blank" rel="noreferrer">short link.</a>
            </p>
        </div>
    );
};

export default ConnectTab;